import React, { useEffect, useState } from 'react';
import { Layout, Menu, Popover, Button } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import './Header.css';
import { MenuOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';

const { Header: AntHeader } = Layout;

const Header = () => {
  // const { t } = useTranslation();
  const [open, setOpen] = useState(false)

  return (
    <AntHeader style={{ backgroundColor: '#fff', borderBottom: '1px solid #e8e8e8', position: 'sticky', top: 0, zIndex: 2 }}>
      <div style={{ display: 'flex', alignItems: 'center', maxWidth: '1200px', margin: '0 auto' }}>
        <div className="header-wrap" style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }}>
          KASKEEPER
        </div>
        <div className='desk-header-menu-wrap' style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '16px' }}>
          <MenuView />
          <LanguageSwitcher />
        </div>
        <div className='mobile-header-menu-wrap' style={{ display: 'none', marginLeft: 'auto' }}>
          <Popover
            maxWidth={200}
            placement={'bottomRight'}
            content={
              <div style={{ textAlign: 'center' }}>
                <MenuView mode="inline" setOpen={setOpen} />
                <LanguageSwitcher style={{ margin: '12px auto 0' }} />
              </div>
            }
            // title="Title"
            trigger={'click'}
            open={open}
            onOpenChange={(newOpen) => {
              console.log('newOpen', newOpen)
              setOpen(() => newOpen);
            }}
          >
            <Button type={'text'} icon={<MenuOutlined style={{ fontSize: '16px' }}/>}
              style={{
                marginRight: -8
              }}
            />
          </Popover>
        </div>
      </div>
    </AntHeader>
  );
};

export default Header;

const MenuView = ({
  mode = 'horizontal',
  setOpen
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <Menu
      mode={mode}
      // mode="inline"
      style={{
        border: 'none',
        minWidth: '560px',
        fontSize: '15px',
        // flexShrink: 0,
        // display: 'flex',
        justifyContent: 'flex-end',
      }}
      selectedKeys={[location.pathname]}
      onClick={(() => {
        console.log('onClick')
        setOpen && setOpen(() => false);
      })}
    >
      <Menu.Item key="/">
        <Link to="/">{t('nav.home')}</Link>
      </Menu.Item>
      <Menu.Item key="/privacy-policy">
        <Link to="/privacy-policy">{t('nav.privacy')}</Link>
      </Menu.Item>
      <Menu.Item key="/tokenscan">
        <Link to="/tokenscan">{t('nav.tokenscan')}</Link>
      </Menu.Item>
      <Menu.Item key="/dapp-api">
        <Link to="/dapp-api">{t('nav.dappapi')}</Link>
      </Menu.Item>
      <Menu.Item key="/wallte-doc">
        <Link to="/wallte-doc">{t('nav.operationManual')}</Link>
      </Menu.Item>
    </Menu>
  );
}
